export const FOOTER = [
    {
        title: 'FOOTER.OFFER',
        menuHandle: 'aj-nlatunk',
        id: 1,
    },
    {
        title: 'FOOTER.ABOUT_US',
        menuHandle: 'inform-ci-k',
        id: 2,
    },
    {
        title: 'FOOTER.INFO',
        menuHandle: 'inform-ci-k-1',
        id: 3,
    },
];
